import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

export const toggleBoxAnimations = [
  trigger('toggleBox', [
    state(
      'open',
      style({
        height: '*',
        opacity: 1,
      })
    ),
    state(
      'closed',
      style({
        height: '4.05em',
        opacity: 0.9,
      })
    ),
    transition('open => closed', [animate('0.5s ease-in-out')]),
    transition('closed => open', [animate('0.5s ease-in-out')]),
  ]),
];
